module.exports = __webpack_public_path__ + "static/media/heatAttencion.4d2ee7a2.png";